import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

// Default Swiper Initialization Function
function initializeSwiper(containerSelector, options = {}) {
  const swiperContainer = document.querySelector(containerSelector);

  if (!swiperContainer) {
    console.error(
      `Swiper container not found for selector: ${containerSelector}`
    );
    return;
  }

  // Retrieve and parse data-options from the container element
  const dataOptions = swiperContainer.getAttribute("data-options");
  let parsedOptions = {};

  if (dataOptions) {
    try {
      parsedOptions = JSON.parse(dataOptions);
    } catch (error) {
      console.error(`Failed to parse data-options: ${error.message}`);
    }
  }

  // Merge default options, parsed options, and passed options
  const finalOptions = {
    ...parsedOptions,
    ...options,
  };

  return new Swiper(swiperContainer, finalOptions);
}

function swiperFn() {
  const swiper = document.querySelector(".swiper");
  const recommendationSwiper = document.querySelector(".recommendation-swiper");
  const gallery_Top = document.querySelector(".gallery-top");
  const gallery_Thumbs = document.querySelector(".gallery-thumbs");

  if (swiper) {
    initializeSwiper(".swiper", {
      direction: "horizontal",
      loop: false,
    });
  }

  if (recommendationSwiper) {
    initializeSwiper(".recommendation-swiper");
  }

  if (gallery_Top && gallery_Thumbs) {
    const galleryThumbs = initializeSwiper(".gallery-thumbs", {
      direction: "horizontal",
      spaceBetween: 14,
      slidesPerView: 4,
      freeMode: false,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        820: {
          direction: "vertical",
          slidesPerView: 4,
        },
      },
    });

    const galleryTop = initializeSwiper(".gallery-top", {
      direction: "horizontal",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
    galleryTop.on("slideChangeTransitionStart", function () {
      galleryThumbs.slideTo(galleryTop.activeIndex);
    });
    galleryThumbs.on("transitionStart", function () {
      galleryTop.slideTo(galleryThumbs.activeIndex);
    });
  }
}

function responsiveSwiper() {
  const img_banner_images = document.querySelector(
    ".img-banner-wrapper .featured-swiper"
  );
  if (window.innerWidth < 768) {
    const swiper_wrapper = img_banner_images.querySelector("ul");
    swiper_wrapper.classList.add("swiper-wrapper");
    const swiper_slide = swiper_wrapper.querySelectorAll("li");
    for (const item of swiper_slide) {
      item.classList.add("swiper-slide");
    }
    initializeSwiper(".img-banner-wrapper .featured-swiper", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        580: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  } else {
    const swiper_wrapper = img_banner_images.querySelector("ul");
    swiper_wrapper.classList.remove("swiper-wrapper");
    const swiper_slide = swiper_wrapper.querySelectorAll("li");
    for (const item of swiper_slide) {
      item.classList.remove("swiper-slide");
    }
  }
}

document.addEventListener("shopify:section:load", function (event) {
  const section = event.target.querySelector(".swiper");
  if (section) {
    initializeSwiper(".swiper"); // Reinitialize the swiper
  }
});

window.onload = () => {
  swiperFn();
  responsiveSwiper();
};
window.addEventListener("resize", responsiveSwiper);
